import { HttpErrorResponse } from '@angular/common/http';

function isErrorLike(error: unknown): error is Error {
  return (
    error !== null &&
    typeof error === 'object' &&
    'name' in error &&
    'message' in error &&
    typeof (error as any).name === 'string' &&
    typeof (error as any).message === 'string'
  );
}

export function normalizeError(error: unknown): Error {
  // console.error('Normalized error:', error);
  // console.error('Normalized error instance:', error instanceof HttpErrorResponse);

  if (isErrorLike(error)) {
    return error;
  }

  return new Error(String(error));
}
